import React, { useState, createContext, useContext } from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { FileText, List } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import TemplateCollection from './TemplateCollection';
import TemplateMyList from './TemplateMyList';

const TemplateManager = () => {
  const location = useLocation();
  const { isAdmin } = useAuth();

  // For Admin users, show the original single-page view
  if (isAdmin) {
    return <TemplateMyList />;
  }

  // For Customer users, show the tabbed interface with nested routes
  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="px-8 pt-8 pb-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Message Templates</h1>
          <p className="text-gray-600 mt-1">Create, manage, and discover message templates for your business</p>
        </div>
        
        {/* Navigation Tabs */}
        <nav className="flex space-x-8">
          <Link
            to="/template-manager/collection"
            className={`flex items-center space-x-2 px-1 py-3 border-b-2 font-medium text-sm transition-colors ${
              location.pathname === '/template-manager/collection'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <FileText className="w-5 h-5" />
            <span>Collection</span>
          </Link>
          <Link
            to="/template-manager/my-list"
            className={`flex items-center space-x-2 px-1 py-3 border-b-2 font-medium text-sm transition-colors ${
              location.pathname === '/template-manager/my-list'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <List className="w-5 h-5" />
            <span>My List</span>
          </Link>
        </nav>
      </div>

      {/* Content Area - Nested routes will be rendered here */}
      <div className="flex-1 px-8 pb-8">
        <Outlet />
    </div>
    </div>
  );
};

export default TemplateManager;